import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";

const Menu = ({ items = [], className = "", onClick ,arrowClass}) => {
  const { t, isRTL } = useLanguage();

  return (
    <div
      className={`bg-white  rounded-lg shadow-xl border border-primary py-2 mt-1 md:mt-1 min-w-[160px] ${className}`}
    >
      <div
        className={`absolute -top-[1px]  md:right-2 ${isRTL ? " left-2 " : " right-2 "}  w-3 h-3 bg-white transform -rotate-45  border-t border-r border-primary ${arrowClass}`}
      ></div>

      {items.map((item, index) => {
        if (item.type === "divider") {
          return (
            <div
              key={item.key || index}
              className="border-t border-gray-200 my-1"
            />
          );
        }

        const handleClick = (e) => {
          if (item.onClick) {
            item.onClick(e);
          }
          if (onClick) {
            onClick(item, e);
          }
        };

        const baseClasses = `flex items-center gap-3 px-4 py-2 transition-colors text-sm md:text-md w-full ${
          isRTL ? "text-right" : "text-left"
        }  ${
          item.disabled
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-700 hover:bg-gray-100 cursor-pointer"
        } ${item.className || ""}`;

        const content = (
          <>
            {item.icon && <span className="flex-shrink-0">{item.icon}</span>}
            <span className="flex-1">{item.label}</span>
          </>
        );

        if (item.href) {
          return (
            <Link
              key={item.key || index}
              to={item.href}
              className={baseClasses}
              onClick={handleClick}
            >
              {content}
            </Link>
          );
        }

        return (
          <button
            key={item.key || index}
            className={baseClasses}
            onClick={handleClick}
            disabled={item.disabled}
          >
            {content}
          </button>
        );
      })}
    </div>
  );
};

export const MenuItem = ({
  key,
  label,
  icon,
  href,
  onClick,
  disabled,
  className,
}) => ({
  key,
  label,
  icon,
  href,
  onClick,
  disabled,
  className,
});

/**
 * Menu Divider Helper
 * @param {string} key - Unique key
 */
export const MenuDivider = ({ key }) => ({
  key,
  type: "divider",
});

export default Menu;
